(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      /*
        The mobile menu owns vertical scrolling while it is open. Do not run the
        sticky-header hide/reveal loop against drawer gestures because that causes
        repeated layout work, visible lag, and can move the drawer under the finger.
      */
      if (document.body.classList.contains('elura-mobile-menu-locked')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const drawer = document.querySelector('[data-elura-cart-drawer]');
    const trigger = document.getElementById('cart-icon-bubble');

    if (!drawer || !trigger || drawer.dataset.initialized === 'true') return;

    drawer.dataset.initialized = 'true';

    // Important: the header section can be sticky, translated, or clipped by the theme.
    // Moving the fixed drawer to <body> makes its top edge truly match the viewport,
    // so the cart icon, title, and close button cannot be pushed above the screen.
    const ownerSection = drawer.closest('.shopify-section');
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    const panel = drawer.querySelector('[data-elura-cart-panel]');
    const itemsContainer = drawer.querySelector('[data-elura-cart-items]');
    const totalElement = drawer.querySelector('[data-elura-cart-total]');
    const statusElement = drawer.querySelector('[data-elura-cart-status]');
    const checkoutButton = drawer.querySelector('[data-elura-cart-checkout]');
    const checkoutDiscountInput = drawer.querySelector('[data-elura-cart-discount]');
    const closeButtons = drawer.querySelectorAll('[data-elura-cart-close]');
    const countBubble = trigger.querySelector('[data-elura-cart-count-bubble]');
    const countElement = trigger.querySelector('[data-elura-cart-count]');
    const rootUrl = drawer.dataset.rootUrl || '/';
    const cartEndpoint = `${rootUrl.replace(/\/$/, '')}/cart.js`;
    const changeEndpoint = `${rootUrl.replace(/\/$/, '')}/cart/change.js`;
    const updateEndpoint = `${rootUrl.replace(/\/$/, '')}/cart/update.js`;
    const checkoutForm = checkoutButton?.closest('form') || null;
    const currencyFallback = drawer.dataset.currency || 'USD';
    const emptyText = drawer.dataset.emptyText || 'Your cart is empty.';

    let lastFocusedElement = null;
    let isUpdating = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragDeltaX = 0;
    let isDragging = false;
    let checkoutNavigating = false;

    const escapeHtml = (value) => {
      const div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    };

    const formatMoney = (cents, currency) => {
      const amount = Number(cents || 0) / 100;
      const code = currency || currencyFallback;

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: code,
        }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} ${code}`;
      }
    };

    const setStatus = (message) => {
      if (statusElement) statusElement.textContent = message || '';
    };

    const setBusy = (busy) => {
      isUpdating = busy;
      drawer.toggleAttribute('aria-busy', busy);
      drawer.querySelectorAll('[data-cart-action]').forEach((button) => {
        button.disabled = busy;
      });
    };

    const getFocusableElements = () => {
      if (!panel) return [];
      return Array.from(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);
    };

    const openDrawer = async () => {
      lastFocusedElement = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('elura-cart-drawer-open');
      if (ownerSection) ownerSection.classList.add('elura-cart-section-open');

      requestAnimationFrame(() => {
        const closeButton = drawer.querySelector('.elura-cart-drawer__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });

      try {
        await refreshCart();
      } catch (error) {
        setStatus('Unable to refresh cart. Please try again.');
      }
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open', 'is-dragging');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('elura-cart-drawer-open');
      if (ownerSection) ownerSection.classList.remove('elura-cart-section-open');

      if (panel) {
        panel.style.transform = '';
      }
      const backdrop = drawer.querySelector('.elura-cart-drawer__backdrop');
      if (backdrop) backdrop.style.opacity = '';

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    };

    const updateCountBubble = (count) => {
      if (!countBubble || !countElement) return;
      countElement.textContent = count;
      countBubble.classList.toggle('hidden', count === 0);
    };

    const originalLinePrice = (item) => {
      const candidate = item?.original_line_price ?? item?.line_price ?? item?.final_line_price ?? 0;
      return Math.max(0, Number(candidate) || 0);
    };

    const finalLinePrice = (item) => Math.max(0, Number(item?.final_line_price ?? item?.line_price ?? 0) || 0);

    const hasServerDiscount = (item) => {
      if (finalLinePrice(item) < originalLinePrice(item)) return true;
      return Array.isArray(item?.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0;
    };

    const bundleInfo = (items) => {
      const first = items[0] || {};
      const properties = first.properties || {};
      const discount = Math.max(0, Math.min(100, Number(properties._elura_bundle_discount) || 0));
      const original = items.reduce((sum, item) => sum + originalLinePrice(item), 0);
      const serverFinal = items.reduce((sum, item) => sum + finalLinePrice(item), 0);
      const intendedFinal = Math.round(original * (100 - discount) / 100);
      const serverDiscountApplied = items.some(hasServerDiscount);
      const code = String(properties._elura_bundle_code || '').trim();
      const cartLabel = String(properties._elura_bundle_cart_label || 'Bundle').trim() || 'Bundle';
      const tierLabel = String(properties._elura_bundle_label || '').trim();
      const declaredQuantity = Math.max(1, Number(properties._elura_bundle_quantity) || 0);
      const actualQuantity = items.reduce((sum, item) => sum + Math.max(0, Number(item.quantity) || 0), 0);

      return {
        discount,
        original,
        serverFinal,
        intendedFinal,
        serverDiscountApplied,
        code,
        cartLabel,
        tierLabel,
        quantity: declaredQuantity || actualQuantity || 1,
        actualQuantity: actualQuantity || declaredQuantity || 1,
      };
    };

    const buildCartPresentation = (cart) => {
      const entries = [];
      const bundleGroups = new Map();

      (cart.items || []).forEach((item) => {
        const bundleId = String(item?.properties?._elura_bundle_id || '').trim();
        if (!bundleId) {
          entries.push({ type: 'item', item });
          return;
        }

        let entry = bundleGroups.get(bundleId);
        if (!entry) {
          entry = { type: 'bundle', id: bundleId, items: [] };
          bundleGroups.set(bundleId, entry);
          entries.push(entry);
        }
        entry.items.push(item);
      });

      const bundleEntries = entries.filter((entry) => entry.type === 'bundle');
      const hasRegularItems = entries.some((entry) => entry.type === 'item');
      const checkoutCodes = [...new Set(
        bundleEntries
          .map((entry) => bundleInfo(entry.items).code)
          .filter(Boolean)
      )];
      const checkoutDiscounts = [...new Set(
        bundleEntries
          .map((entry) => bundleInfo(entry.items).discount)
          .filter((value) => value > 0)
      )];

      // A single code is only auto-applied when it cannot accidentally discount unrelated
      // cart lines or mix two bundle tiers with different percentages.
      const checkoutCode = !hasRegularItems && checkoutCodes.length === 1 && checkoutDiscounts.length === 1
        ? checkoutCodes[0]
        : '';

      let displayTotal = 0;
      entries.forEach((entry) => {
        if (entry.type === 'item') {
          displayTotal += finalLinePrice(entry.item);
          return;
        }

        const info = bundleInfo(entry.items);
        const canUseIntendedPrice = info.serverDiscountApplied || (checkoutCode && info.code === checkoutCode);
        displayTotal += info.serverDiscountApplied
          ? info.serverFinal
          : canUseIntendedPrice
            ? info.intendedFinal
            : info.serverFinal;
      });

      return { entries, checkoutCode, displayTotal };
    };

    const renderRegularItem = (item, currency) => {
      const title = escapeHtml(item.product_title || item.title || '');
      const url = escapeHtml(item.url || '#');
      const imageUrl = item.image ? escapeHtml(item.image) : '';
      const imageAlt = title;
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="elura-cart-item__variant">${escapeHtml(item.variant_title)}</p>`
        : '';

      const properties = Object.entries(item.properties || {})
        .filter(([name, value]) => value && !String(name).startsWith('_'))
        .map(([name, value]) => `<p class="elura-cart-item__property">${escapeHtml(name)}: ${escapeHtml(value)}</p>`)
        .join('');

      return `
        <li class="elura-cart-item" data-elura-cart-item data-key="${escapeHtml(item.key)}">
          <a class="elura-cart-item__media" href="${url}" tabindex="-1" aria-hidden="true">
            ${imageUrl ? `<img src="${imageUrl}" alt="${imageAlt}" loading="lazy" width="200" height="250">` : ''}
          </a>
          <div class="elura-cart-item__content">
            <a class="elura-cart-item__title" href="${url}">${title}</a>
            ${variantTitle}
            ${properties}
            <div class="elura-cart-item__price">${formatMoney(finalLinePrice(item), currency)}</div>
            <div class="elura-cart-item__controls" aria-label="Quantity controls for ${title}">
              <button class="elura-cart-item__qty-button" type="button" data-cart-action="decrease" aria-label="Decrease quantity">−</button>
              <span class="elura-cart-item__qty" data-elura-cart-quantity>${Number(item.quantity || 0)}</span>
              <button class="elura-cart-item__qty-button" type="button" data-cart-action="increase" aria-label="Increase quantity">+</button>
              <button class="elura-cart-item__remove" type="button" data-cart-action="remove" data-cart-key="${escapeHtml(item.key)}" aria-label="Remove ${title}">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                  <path d="M5 7.5h14"/>
                  <path d="M9.25 5h5.5"/>
                  <path d="M10 5h4a1 1 0 0 1 1 1v1.5H9V6a1 1 0 0 1 1-1Z"/>
                  <path d="M8 9l0.85 9.35A1.5 1.5 0 0 0 10.34 19.7h3.32a1.5 1.5 0 0 0 1.49-1.35L16 9"/>
                  <path d="M10.5 11.25v4.5M13.5 11.25v4.5"/>
                </svg>
              </button>
            </div>
          </div>
        </li>`;
    };

    const renderBundle = (entry, currency, checkoutCode) => {
      const items = entry.items || [];
      const first = items[0] || {};
      const info = bundleInfo(items);
      const titleText = first.product_title || first.title || '';
      const title = escapeHtml(`${titleText} ${info.cartLabel}`.trim());
      const url = escapeHtml(first.url || '#');
      const imageUrl = first.image ? escapeHtml(first.image) : '';
      const canUseIntendedPrice = info.serverDiscountApplied || (checkoutCode && info.code === checkoutCode);
      const displayedFinal = info.serverDiscountApplied
        ? info.serverFinal
        : canUseIntendedPrice
          ? info.intendedFinal
          : info.serverFinal;
      const showCompare = displayedFinal < info.original;
      const variantRows = items
        .map((item) => {
          const variant = item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : 'Standard';
          const quantity = Math.max(1, Number(item.quantity) || 1);
          return `<p class="elura-cart-bundle__variant">${escapeHtml(variant)}${quantity > 1 ? ` × ${quantity}` : ''}</p>`;
        })
        .join('');
      const tierText = info.tierLabel || `${info.actualQuantity} items`;
      const badgeText = info.discount > 0 ? `${info.cartLabel} · ${info.discount}% off` : info.cartLabel;
      const keys = escapeHtml(JSON.stringify(items.map((item) => item.key).filter(Boolean)));

      return `
        <li class="elura-cart-bundle" data-elura-cart-bundle data-bundle-keys="${keys}">
          <a class="elura-cart-bundle__media" href="${url}" tabindex="-1" aria-hidden="true">
            ${imageUrl ? `<img src="${imageUrl}" alt="${title}" loading="lazy" width="200" height="250">` : ''}
          </a>
          <div class="elura-cart-bundle__content">
            <span class="elura-cart-bundle__badge">${escapeHtml(badgeText)}</span>
            <a class="elura-cart-bundle__title" href="${url}">${title}</a>
            <div class="elura-cart-bundle__variants">${variantRows}</div>
            <p class="elura-cart-bundle__meta">${escapeHtml(tierText)} · ${info.actualQuantity} ${info.actualQuantity === 1 ? 'item' : 'items'}</p>
            <div class="elura-cart-bundle__price-row">
              <span class="elura-cart-bundle__price">${formatMoney(displayedFinal, currency)}</span>
              ${showCompare ? `<span class="elura-cart-bundle__compare">${formatMoney(info.original, currency)}</span>` : ''}
            </div>
            <div class="elura-cart-bundle__controls">
              <span class="elura-cart-bundle__meta">Sold as one bundle</span>
              <button class="elura-cart-bundle__remove" type="button" data-cart-action="remove-bundle" aria-label="Remove ${title}">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                  <path d="M5 7.5h14"/>
                  <path d="M9.25 5h5.5"/>
                  <path d="M10 5h4a1 1 0 0 1 1 1v1.5H9V6a1 1 0 0 1 1-1Z"/>
                  <path d="M8 9l0.85 9.35A1.5 1.5 0 0 0 10.34 19.7h3.32a1.5 1.5 0 0 0 1.49-1.35L16 9"/>
                  <path d="M10.5 11.25v4.5M13.5 11.25v4.5"/>
                </svg>
              </button>
            </div>
          </div>
        </li>`;
    };

    const renderCart = (cart) => {
      const isEmpty = !cart.items || cart.items.length === 0;
      drawer.classList.toggle('is-empty', isEmpty);
      updateCountBubble(Number(cart.item_count || 0));

      const presentation = buildCartPresentation(cart);

      if (totalElement) {
        totalElement.textContent = formatMoney(presentation.displayTotal, cart.currency);
      }

      if (checkoutButton) {
        checkoutButton.disabled = isEmpty;
        if (presentation.checkoutCode) {
          checkoutButton.dataset.eluraBundleCheckoutCode = presentation.checkoutCode;
        } else {
          delete checkoutButton.dataset.eluraBundleCheckoutCode;
        }
      }

      if (checkoutDiscountInput) {
        checkoutDiscountInput.value = presentation.checkoutCode || '';
        checkoutDiscountInput.disabled = !presentation.checkoutCode;
      }

      if (!itemsContainer) return;

      if (isEmpty) {
        itemsContainer.innerHTML = '';
        const emptyElement = drawer.querySelector('[data-elura-cart-empty]');
        if (emptyElement) emptyElement.textContent = emptyText;
        return;
      }

      itemsContainer.innerHTML = presentation.entries
        .map((entry) => entry.type === 'bundle'
          ? renderBundle(entry, cart.currency, presentation.checkoutCode)
          : renderRegularItem(entry.item, cart.currency))
        .join('');
    };

    const fetchCart = async () => {
      const response = await fetch(cartEndpoint, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };

    const refreshCart = async () => {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    };

    const changeQuantity = async (key, quantity) => {
      if (isUpdating) return;

      setBusy(true);
      setStatus('Updating cart…');

      try {
        const response = await fetch(changeEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Unable to update cart');
        }

        const cart = await response.json();
        renderCart(cart);
        setStatus('Cart updated.');
        document.dispatchEvent(new CustomEvent('elura:cart-updated', { detail: { cart } }));
      } catch (error) {
        setStatus(error.message || 'Unable to update cart. Please try again.');
        await refreshCart().catch(() => {});
      } finally {
        setBusy(false);
      }
    };



    const removeLineItem = async (key) => {
      const lineKey = String(key || '').trim();
      if (!lineKey || isUpdating) return;

      setBusy(true);
      setStatus('Removing item…');

      const requestOptions = (body) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify(body),
      });

      const responseCart = async (response) => {
        const payload = await response.json().catch(() => null);
        if (!response.ok) {
          const message = payload?.description || payload?.message || 'Unable to remove item';
          throw new Error(message);
        }
        return payload;
      };

      const stillContainsLine = (cart) =>
        Boolean((cart?.items || []).some((item) => String(item?.key || '') === lineKey));

      try {
        /*
          Primary removal path: Shopify's documented line-item key support.
          This removes exactly the clicked cart line, even when multiple variants
          of the same product exist in the cart.
        */
        let response = await fetch(
          changeEndpoint,
          requestOptions({ id: lineKey, quantity: 0 })
        );
        let cart = await responseCart(response);

        /*
          Some cart apps can make /cart/change.js accept the request but leave the
          keyed line in the cart. Verify the result and retry through /cart/update.js.
        */
        if (!cart || stillContainsLine(cart)) {
          response = await fetch(
            updateEndpoint,
            requestOptions({ updates: { [lineKey]: 0 } })
          );
          cart = await responseCart(response);
        }

        /*
          Final fallback: resolve the CURRENT Shopify line number immediately before
          removal. This avoids stale line indexes after quantity changes or app edits.
        */
        if (!cart || stillContainsLine(cart)) {
          const currentCart = await fetchCart();
          const lineIndex = (currentCart.items || []).findIndex(
            (item) => String(item?.key || '') === lineKey
          );

          if (lineIndex === -1) {
            cart = currentCart;
          } else {
            response = await fetch(
              changeEndpoint,
              requestOptions({ line: lineIndex + 1, quantity: 0 })
            );
            cart = await responseCart(response);
          }
        }

        /*
          Always pull one fresh cart snapshot after a delete. This keeps the drawer,
          cart counter, subtotal, bundles, and any Shopify cart app in sync.
        */
        const freshCart = await fetchCart().catch(() => cart);
        if (freshCart && stillContainsLine(freshCart)) {
          throw new Error('The item could not be removed. Please try again.');
        }

        if (freshCart) renderCart(freshCart);
        setStatus('Item removed.');
        document.dispatchEvent(
          new CustomEvent('elura:cart-updated', { detail: { cart: freshCart || cart } })
        );
      } catch (error) {
        console.error('[ELURA cart] Remove item failed:', error);
        setStatus(error.message || 'Unable to remove item. Please try again.');
        await refreshCart().catch(() => {});
      } finally {
        setBusy(false);
      }
    };

    const removeBundle = async (keys) => {
      const validKeys = Array.isArray(keys) ? keys.filter(Boolean) : [];
      if (!validKeys.length || isUpdating) return;

      setBusy(true);
      setStatus('Removing bundle…');

      try {
        const updates = {};
        validKeys.forEach((key) => { updates[key] = 0; });
        const response = await fetch(updateEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Unable to remove bundle');
        }

        const cart = await response.json();
        renderCart(cart);
        setStatus('Bundle removed.');
        document.dispatchEvent(new CustomEvent('elura:cart-updated', { detail: { cart } }));
      } catch (error) {
        setStatus(error.message || 'Unable to remove bundle. Please try again.');
        await refreshCart().catch(() => {});
      } finally {
        setBusy(false);
      }
    };

    trigger.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const triggerAnimation = trigger.dataset.eluraCartTriggerAnimation || 'none';
        const triggerAnimationDuration = Math.max(0, Number(trigger.dataset.eluraCartTriggerAnimationDuration) || 300);

        if (triggerAnimation !== 'none') {
          trigger.classList.remove('is-click-animating');
          void trigger.offsetWidth;
          trigger.classList.add('is-click-animating');
          window.setTimeout(() => {
            trigger.classList.remove('is-click-animating');
          }, triggerAnimationDuration + 50);
        }

        openDrawer();
      },
      true
    );

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    /*
      Capture cart actions at the drawer level instead of relying on a bubbling
      listener on the item list. This makes Delete reliable even when another
      theme/app script stops propagation on cart buttons.
    */
    drawer.addEventListener(
      'click',
      (event) => {
        const eventTarget = event.target instanceof Element ? event.target : null;
        const actionButton = eventTarget?.closest('[data-cart-action]');
        if (!actionButton || !drawer.contains(actionButton)) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (isUpdating) return;

        const action = actionButton.dataset.cartAction;

        if (action === 'remove-bundle') {
          const bundleItem = actionButton.closest('[data-elura-cart-bundle]');
          if (!bundleItem) return;

          let keys = [];
          try {
            keys = JSON.parse(bundleItem.dataset.bundleKeys || '[]');
          } catch (error) {
            keys = [];
          }

          void removeBundle(keys);
          return;
        }

        const item = actionButton.closest('[data-elura-cart-item]');
        if (!item) return;

        const key = String(item.dataset.key || actionButton.dataset.cartKey || '').trim();
        const quantityElement = item.querySelector('[data-elura-cart-quantity]');
        const currentQuantity = Number(quantityElement?.textContent || 0);

        if (action === 'increase') {
          void changeQuantity(key, currentQuantity + 1);
        } else if (action === 'decrease') {
          void changeQuantity(key, Math.max(0, currentQuantity - 1));
        } else if (action === 'remove') {
          void removeLineItem(key);
        }
      },
      true
    );

    if (checkoutForm && checkoutButton) {
      const continueToBundleCheckout = (event) => {
        const code = String(checkoutButton.dataset.eluraBundleCheckoutCode || '').trim();
        if (!code) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        if (checkoutNavigating) return;
        checkoutNavigating = true;

        if (checkoutDiscountInput) {
          checkoutDiscountInput.value = code;
          checkoutDiscountInput.disabled = false;
        }

        const cleanRoot = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
        const encodedCode = encodeURIComponent(code);
        const checkoutPath = `${cleanRoot}checkout?discount=${encodedCode}`;
        const discountPath = `${cleanRoot}discount/${encodedCode}?redirect=${encodeURIComponent(checkoutPath)}`;

        // The /discount route persists the code in Shopify, while the checkout query
        // parameter is a second handoff for browsers that start a fresh checkout session.
        window.location.assign(discountPath);
      };

      checkoutButton.addEventListener('click', continueToBundleCheckout, true);
      checkoutForm.addEventListener('submit', continueToBundleCheckout, true);
    }

    document.addEventListener('elura:cart:updated', () => {
      refreshCart().catch(() => {});
    });

    document.addEventListener('cart:refresh', () => {
      refreshCart().catch(() => {});
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (panel && window.PointerEvent) {
      panel.addEventListener('pointerdown', (event) => {
        if (!drawer.classList.contains('is-open')) return;
        if (event.pointerType === 'mouse') return;
        if (event.target.closest('button, a, input, select, textarea')) return;

        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragDeltaX = 0;
        isDragging = false;
      });

      panel.addEventListener('pointermove', (event) => {
        if (!dragStartX && !dragStartY) return;

        const deltaX = event.clientX - dragStartX;
        const deltaY = event.clientY - dragStartY;

        if (!isDragging) {
          if (Math.abs(deltaY) > Math.abs(deltaX) || deltaX < 8) return;
          isDragging = true;
          drawer.classList.add('is-dragging');
        }

        if (deltaX <= 0) return;

        dragDeltaX = Math.min(deltaX, panel.offsetWidth);
        panel.style.transform = `translateX(${dragDeltaX}px)`;

        const backdrop = drawer.querySelector('.elura-cart-drawer__backdrop');
        if (backdrop) {
          const progress = Math.min(1, dragDeltaX / Math.max(panel.offsetWidth, 1));
          const baseOpacity = Number(getComputedStyle(drawer).getPropertyValue('--elura-cart-overlay-opacity')) || 0.35;
          backdrop.style.opacity = String(baseOpacity * (1 - progress));
        }
      });

      const finishSwipe = () => {
        if (!dragStartX && !dragStartY) return;

        const threshold = Math.min(120, panel.offsetWidth * 0.25);
        const shouldClose = isDragging && dragDeltaX >= threshold;

        dragStartX = 0;
        dragStartY = 0;
        dragDeltaX = 0;
        isDragging = false;
        drawer.classList.remove('is-dragging');

        const backdrop = drawer.querySelector('.elura-cart-drawer__backdrop');
        if (backdrop) backdrop.style.opacity = '';
        panel.style.transform = '';

        if (shouldClose) closeDrawer();
      };

      panel.addEventListener('pointerup', finishSwipe);
      panel.addEventListener('pointercancel', finishSwipe);
    }

    document.addEventListener('elura:cart-refresh', () => {
      refreshCart().catch(() => {});
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (!ownerSection || event.target !== ownerSection) return;
      document.body.classList.remove('elura-cart-drawer-open');
      ownerSection.classList.remove('elura-cart-section-open');
      drawer.remove();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
